import React from "react";
import styled from "styled-components";

const StyledTab = styled.span`
  min-width: 80px;
  min-height: 40px;
  border-radius: 24px;
  border: 1px solid transparent;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.gray400};
  }
  &:active {
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    background-color: ${({ theme }) => theme.colors.gray400};
  }
`;

const TabBtn = ({ children, className, onClick }) => {
  return (
    <StyledTab onClick={onClick} className={className}>
      {children}
    </StyledTab>
  );
};

export default TabBtn;
